export const timeFrameValues = ["<1mo", "1-3mo", "3-6mo", "6-12mo", "1y+"];
